<template>
  <!-- pagina prodotto -->
  <div class="paginaprodotto display_flex_pagina_prodotto">
    <div class="div_border GROUPVUE_WRAPPER_LIST">
      <div class="wrapper-list wrapper-list-modelli">
        <!-- list-modelli -->
        <imagemobile></imagemobile>
        <modelli></modelli>
        <!-- /list-modelli-->
      </div>
    </div>

    <div class="div_border GROUPVUE_WRAPPER_LIST list_vetri_wrapper_container">
      <div class="test_div"></div>
      <div class="wrapper-list vetro_wrapper">
        <!-- list-vetro  -->

        <div class="list-vetro">
          <div
            class="finitura_vetro testo_finitura_vetro maiuscoletto_opaco_piccolo"
          >
            <p class="count_proddoto">{{ finituravetro_text_ }}</p>
          </div>
          <div class="vetro-slider">
            <vetro></vetro>
          </div>
          <!--       <div class="data-vetro develop-info"  v-show="debug" >
                                  <pre> {{ data.sorgente}} {{data.prodotti}} {{ data.vetro}} </pre> </div>
                                 </div>
                                -->
          <!-- /list-vetro -->
        </div>
      </div>

      <div
        class="div_border GROUPVUE_WRAPPER_LIST montatura_margin list_finiture_wrapper_container"
      >
        <div class="test_div"></div>
        <div
          class="wrapper-list finiture-montature-09587"
          v-if="visualizza_1010"
        >
          <!-- list-finiture-montature  -->
          <div class="list-finiture-montature">
            <div class="finitura_montatura maiuscoletto_opaco_piccolo">
              <p class="finitura_montatura">{{ finituramontatura }}</p>
            </div>
            <!-- parte delle montature eee -->
            <montatura></montatura>
            <!-- fine  parte delle montature -->
          </div>
          <!-- /list-finiture-montature -->
        </div>
      </div>

      <div class="div_border GROUPVUE_WRAPPER_LIST">
        <div class="wrapper-list paese_wrapper">
          <paese> </paese>
        </div>
      </div>

      <div class="div_border GROUPVUE_WRAPPER_LIST">
        <div class="wrapper-list sorgente_luminosa_wrapper">
          <!-- list-sorgente-luminosa  -->
          <div class="list-sorgente-luminosa">
            <!--  parte e del vetro -->
            <div class="sorgente_luminosa_p maiuscoletto_opaco_piccolo">
              <p class="sorgente_luminosa_padding_zero">
                {{ sorgenteluminosa_ }}
              </p>
            </div>
            <!-- select fluid -->
            <!--    -->
            <ledselect> </ledselect>
          </div>
          <!-- /list-sorgente-luminosa -->
        </div>
      </div>

      <div class="div_border GROUPVUE_WRAPPER_LIST">
        <div class="wrapper-list certificazioni_wrapper">
          <!-- list-certificazioni  -->
          <!-- <p class="padding-title">{{ certificazioni }}</p> -->
          <div class="titoletto_certificazioni maiuscoletto_opaco_piccolo">
            <p class="">{{ certificazioniTitolo }}</p>
          </div>
          <certificazioni></certificazioni>
          <!-- /list-certificazioni -->
        </div>
      </div>

      <div class="div_border GROUPVUE_WRAPPER_LIST">
        <div class="wrapper-list codice_articolo_wrapper">
          <!-- list-codicearticolo  -->
          <codicearticolo />
          <!-- /list-codicearticolo -->
        </div>
      </div>

      <div class="div_border GROUPVUE_WRAPPER_LIST">
        <div class="wrapper-list list_dispo_wrapper">
          <!-- list-disponibilita_tot  -->
          <disponibilita> </disponibilita>
          <!-- /list-disponibilita -->
        </div>
      </div>

      <div class="div_border GROUPVUE_WRAPPER_LIST">
        <div
          class="sorgente_luminosa_p maiuscoletto_opaco_piccolo"
          v-if="logged_in"
        >
          <p class="">{{ prezzo_title_unitario }}</p>
        </div>
      </div>
      <div class="div_border GROUPVUE_WRAPPER_LIST prezzo_unitario_flex">
        <div class="prezzo">
          <p class="prezzo_unitario" v-if="logged_in">
            {{ prezzounitario }} {{ valuta }}
          </p>
        </div>

        <div class="wrapper-list quantity_wrapper">
          <div class="quantity_toggle quantity_toggle_position">
            <button class="quantity_toggle_button" @click="decrement()">
              &mdash;
            </button>
            <input
              class="quantity_toggle_input"
              type="text"
              :value="quantity"
              readonly
            />
            <button class="quantity_toggle_button" @click="increment()">
              &#xff0b;
            </button>
          </div>
        </div>
      </div>
      <div class="prezzo_scontato_wrapper" v-if="discounted">
        <div class="sorgente_luminosa_p maiuscoletto_opaco_piccolo">
          <p class="" style="padding-top: 12px; font-size: 13px !important">
            {{ prezzo_title_unitario_scontato }}
          </p>
        </div>
        <div class="prezzo_scontato">
          <p
            class="prezzo_unitario"
            style="padding-top: 12px; font-size: 13px !important"
            v-if="logged_in"
          >
            {{ discountd_price }} {{ valuta }}
          </p>
        </div>
      </div>

      <div class="div_border GROUPVUE_WRAPPER_LIST">
        <!-- list-quantità  -->
        <div class="list-quantità padding-title"></div>
        <!-- list-certificazioni  -->
        <div class="list-certificazioni"></div>
        <!-- /list-certificazioni -->
        <!-- list-codicearticolo  -->
        <div class="list-prezzo padding-title">
          <div class="sorgente_luminosa_p maiuscoletto_opaco_piccolo">
            <p class="">{{ prezzo_title }}</p>
          </div>

          <prezzo></prezzo>
        </div>

        <!-- /list-quantità -->
      </div>
      <!-- WISH LIST -->
      <div class="button" v-if="not_logged_in">
        <div class="container_pulsante">
          <div class="whishlist" @click="add_to_wishlist">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="52.005"
              height="37.82"
              viewBox="0 0 52.005 37.82"
            >
              <g id="heart_wishlist" transform="translate(-1670.995 -45)">
                <path
                  id="Tracciato_51060"
                  data-name="Tracciato 51060"
                  d="M947.283,559c-5.1-9.04-16.757-6.676-18.146,1.614-1.516,9.047,8.975,18.728,18.146,24.152,9.169-5.425,19.99-15.063,18.145-24.152-1.672-8.238-13.044-10.655-18.145-1.614"
                  transform="translate(743.01 -502.943)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <!--  <g id="Wishlist_Number" transform="translate(27 -31)" >
                <circle id="Ellisse_268" class="cicle_stroke" data-name="Ellisse 268" stoke="white" cx="13" cy="13" r="13" transform="translate(1670 76)"/>
                <text id="number_items_3" data-name="1" transform="translate(1678 95)" fill="#000" font-size="17" font-family="Montserrat-Medium, Montserrat" font-weight="500" opacity="0.99"><tspan id ="text_cuore" x="0" y="0">{{ l }}</tspan></text>
            </g> -->
              </g>
            </svg>
            <p class="text_addwishlist">{{ add_to_wishlist_text }} ({{ l }})</p>
          </div>
        </div>
      </div>
      <!-- WISH LIST END -->

      <div class="div_border GROUPVUE_WRAPPER_LIST">
        <div class="wrapper-list prezzo_wrapper">
          <!-- list-prezzo  -->
          <div class="button-buy-under-text-center">
            <ordina> </ordina>
            <!--
                                                <v-btn     v-show="debug" @click = get_product_a() > get product </v-btn>
                                                <v-btn     v-show="debug" @click = get_products_e() > get products </v-btn>
                                                <v-btn     v-show="debug" @click = altro_g() > test </v-btn>
                                                <v-btn      v-show="debug" @click = get_products_e() > get products </v-btn>
                                              -->
          </div>

          <!-- /list-prezzo -->
        </div>
      </div>

      <div class="div_border GROUPVUE_WRAPPER_LIST">
        <!-- / pagina prodotto -->
        <div style="display: none; with: 20px">
          <input
            type="checkbox"
            @click="debug_method()"
            style="border: 1px solid black; with: 20px"
          />
        </div>
        <!-- questa parte e del vetro -->
      </div>
    </div>
  </div>
</template>
<script>
//   import Json from "../testdata/a.json"
//import Axios from "axios";
import disponibilita from "./disponibilita.vue";
import modelli from "./listmodelli.vue";
//import modelligroup from './modelligroup.vue'
import vetro from "./vetri_new.vue";
import montatura from "./montatura.vue";
import ledselect from "./sorgente.vue";
import certificazioni from "./certificazioni.vue";
import codicearticolo from "./codicearticolo.vue";
import paese from "./paese.vue";
import prezzo from "./prezzo.vue";

import ordina from "./ordina.vue";
import STATUS from "../classes/start_helper";
import get_json_product from "../classes/class_get_json_product";
import checkLanguage from "../classes/class_check_language";
import imagemobile from "./imagemobile.vue";
/** WHISLIST */
import cookie_class from "../classes/cookie_class";
/** WHISLIST END */
export default {
  name: "groupvue",
  data: () => ({
    add_to_wishlist_text: "AGGIUNGI ALLA WISHLIST",
    el2: "",
    logged_in: false,
    not_logged_in: true,
    select_montature_by_finiture_metalliche_count: 0,
    select_montature_by_vetro_count: 0,
    listacontuttelesorgenti: "",
    quantity: 1,
    dialog: false,
    dialogtitle: "",
    model: null,
    model2: null,
    model3: null,
    SORGENTE: "",
    SORGENTI: [],
    mah: "",
    europe: {
      SELECTED: true,
    },
    usa: {
      SELECTED: false,
    },
    url: "",
    finituravetro: "",
    finituramontatura: "FINITURA STRUTTURA",
    certificazioniTitolo: "CERTIFICAZIONI",
    prezzo_title_unitario: "PREZZO",
    prezzo_title_unitario_scontato: "PREZZO SCONTATO",

    prezzo_title: "SUBTOTALE",
    prezzo: "735,00",
    items: [
      { id: "a", name: "b" },
      { id: "a", name: "b" },
    ],
    test: {},
    data: "",
    el: "",
    visualizza_1010: "",
    /** wishlist */
    l: 0,
    display_number: false,
    /** wishlist end */
  }),
  components: {
    disponibilita,
    modelli,
    paese,
    vetro,
    montatura,
    ledselect,
    certificazioni,
    codicearticolo,
    prezzo,
    ordina,
    imagemobile,
  },
  mounted() {
    /**  INIZIO CODICE PER WISHLIST */

    let t = new cookie_class();
    let n = t.product_number("products");
    console.info("prodotti in cookie", n);
    if (n > 0) {
      this.l = n;
      console.info("prodotti in cookie l", this.l);
      this.display_number = true;
      console.info("this display number", this.display_number);
    }

    let el2 = document.getElementById("number_items");
    this.el2 = el2;

    /**  FINE  CODICE PER WISHLIST */

    if (document.body.classList.contains("logged-in")) {
      // Do something
      this.logged_in = true;
      this.not_logged_in = false;
    }
    // controllo se inglese
    let i = new checkLanguage();
    if (!i.is_italian()) {
      this.add_to_wishlist_text = "ADD TO WISHLIST";
      this.finituramontatura = "FRAME FINISH";
      this.certificazioniTitolo = "CERTIFICATIONS";
      this.prezzo_title = "SUBTOTAL";
      this.finituravetro_text_ = "GLASS FINISH";
      this.sorgenteluminosa_ = "LIGHT SOURCE";
      this.prezzo_title_unitario = "PRICE";
      this.prezzo_title_unitario_scontato = "DISCOUNTED PRICE";
    }
    this.codice_listino = window.descrizione.codice_listino;
    this.skualt = window.descrizione.alt;
    this.discounted = window.descrizione.discounted;
    this.discount_percentage = window.descrizione.discount_percentage;
    this.$store.commit("add_codice_listino", {
      codice_listino: this.codice_listino,
    });
    this.$store.commit("add_codice_alt", { codice_listino: this.skualt });
    this.$store.subscribe((mutation, state) => {
      try {
        this.m = mutation;
        this.s = state;
        this.finitura_struttura_1010 =
          this.$store.state.products_store.FINITURASTRUTTURA_ARRAY;
        if (Array.isArray(this.finitura_struttura_1010)) {
          if (this.finitura_struttura_1010.length > 0) {
            this.finitura_struttura_1010 = this.finitura_struttura_1010[0];
            if (
              typeof this.finitura_struttura_1010.FINITURASTRUTTURA !==
                undefined ||
              this.finitura_struttura_1010.FINITURASTRUTTURA !== null
            ) {
              this.finitura_1010 =
                this.finitura_struttura_1010.FINITURASTRUTTURA;
            }
          } else {
            this.finitura_1010 = "000";
          }
        } else {
          this.finitura_1010 = "000";
        }
        if (this.finitura_1010 === "000") {
          this.visualizza_1010 = false;
        } else {
          this.visualizza_1010 = true;
        }
      } catch (error) {
        console.info(error);
      }
    });
    this.$store.subscribe((mutation, state) => {
      this.state = state;
      if (mutation.type == "json_taken_details") {
        this.$store.commit("filter_for_listino");
      }
      if (mutation.type == "filter_for_listino") {
        // QUI RAGGRUPPO PER MODELLO VETRO FINITURA IN MODO DA AVERE I CONFINI DEL SISTEMA
        this.$store.commit("group_by_model");
      }
      if (mutation.type == "group_by_model") {
        // DEVO VISUALIZZARE I MODELLI PER FARE QUESTO MI SERVE IL VETRO SELEZIONATO
        // GET VETRO BY PRODUCT ID
        this.product_id = window.descrizione.descrizione.codice_univoco;
        this.codice_univoco = window.descrizione.codice_prodotto;
        if (this.codice_univoco) {
          this.product_id = this.codice_univoco;
        }
        this.$store.commit("vetro_by_product_id", {
          product_id: this.product_id,
        });
      }
      if (mutation.type == "vetro_by_product_id") {
        // DEVO VISUALIZZARE I MODELLI PER FARE QUESTO MI SERVE IL VETRO SELEZIONATO
        // GET VETRO BY PRODUCT ID
        this.product_id = window.descrizione.codice_univoco;
        this.$store.commit("filter_modelli", { product_id: this.product_id });
      }
      if (mutation.type == "filter_modelli") {
        this.$store.commit("filter_glass");
      }
      if (mutation.type == "filter_glass") {
        let codice_univoco = this.$store.state.product_store.CODICE_UNIVOCO;
        this.$store.commit("select_product_by_id", codice_univoco);
      }
      // se viene cliccato un modello ...
      if (mutation.type == "search_id_product_by_modello_var") {
        this.$store.commit(
          "select_product_by_id",
          this.$store.state.product_store.CODICE_UNIVOCO_CLICK_MODELLI
        );
        this.$store.commit("new_product_link_search");
      }
    });
  },
  methods: {
    /** WISHILIST  */
    add_to_wishlist() {
      console.info(this.$store.state);
      let id_prodotto = false;
      try {
        id_prodotto = this.$store.state.product_store.CODICE_UNIVOCO;
        console.info();
      } catch (error) {
        console.info(error);
      }
      if (id_prodotto) {
        let t = new cookie_class();
        let k = JSON.stringify(id_prodotto);
        let m = t.pushCookie("products", k);
        // console.info('fatto push cookie', m);
        this.l = m;
        /** aggiungo il numero anche al cuore del menu! */

        // console.info('numers_items');
        // console.info(this.el2);
        // console.info('numers_items');
        this.el2.innerHTML = m;
        if (m == 1) {
          this.el2.setAttribute("transform", "translate(1680 95)");
        } else {
          this.el2.setAttribute("transform", "translate(1678 95)");
        }
        /** aggiungo il numero anche al cuore del menu! end */
        this.display_number = true;
        // console.info('fatto push cookie', this.display_number);
      }
    },
    /** END WISH LIST  */
    switcher() {
      switch (this.COMPONENT_STATUS) {
        case STATUS.TYPE.INIT:
          this.is_url_localhost();
          this.switcher();
          break;
        case STATUS.TYPE.PRODUCTION:
          break;
        case STATUS.TYPE.LOCAL:
          break;
        default:
          break;
      }
    },
    debug_method() {
      this.$store.commit("debug");
    },
    CHANGE_STATUS(status) {
      this.$store.commit("change_status", { status: status });
    },
    CHANGE_URL(URL) {
      this.$store.commit("change_status", { url: URL });
    },

    is_url_localhost() {
      if (this.url != "localhost") {
        this.CHANGE_STATUS(STATUS.TYPE.PRODUCTION);
      } else {
        this.CHANGE_STATUS(STATUS.TYPE.PRODUCTION);
      }
    },

    show_product_id(id) {
      let obj = {
        id: id,
      };
      this.$store.commit("show_product_id", obj);
    },
    product_wid(wid) {
      let obj = {
        wid: wid,
      };
      this.$store.commit("product_wid", obj);
    },
    altro_g() {},
    get_product_a() {},
    get_products_e() {},
    onCardClick(n) {
      // trovo per prima cosa la finitura selezionata... non è necessario
      // adesso so già la finitura selezionata..
      // ma se proprio vogliamo essere pleonastinici...
      this.finituraselected();
      // questa funziona aggiorna i mosdelli nel primo slider a destra
      // queta funzione dovrebbe fare un filtro partendo dalle
      // condizioni presenti in store aggiungendo la condizione del vetro
      // quindi creo due mutation oppure una mutation e una action
      // di sicuro devo commitare che è cambiato il vetro
      let obj = {
        vetro: n,
        vetri: this.data.vetro,
      };
      this.$store.commit("vetro_selected", obj);
      // qui dovrei settare l'opacita del gruppo vetro...
      this.data.vetro = this.$store.getters.get_vetri_selected;
      // qui sotto con filter product for vetro
      // filtro l'array presente sullo store
      // l'array del paese giusto infatti è l'array del paese selezionato
      this.$store.commit("filter_product_for_vetro");
      // poi filtro per finitur e
      this.$store.commit("filter_product_for_finiture");
      // poi filtro per led
      this.$store.commit("filter_product_for_led");
      this.$store.commit("product_selected");
      // mi riporto l'array sul primo gruppo
      // è l'array con i prodotti filtrati nelle righe precedenti
      try {
        if (
          this.$store.getters.get_filtered_produts_vetro_finiture_sorgente
            .length != 0
        ) {
          this.data.details_old =
            this.$store.getters.get_filtered_produts_vetro_finiture_sorgente;
        } else {
          // in questo caso devo richiamare tutto ma cambiare le finiture
          this.$store.commit("change_finitura");
          this.$store.commit("filter_product_for_vetro");
          // poi filtro per finiture
          this.$store.commit("filter_product_for_finiture");
          // poi filtro per led
          this.$store.commit("filter_product_for_led");
          this.$store.commit("product_selected");
          // todo rendere  questo elemento...
          this.data.details_old =
            this.$store.getters.get_filtered_produts_vetro_finiture_sorgente;
        }
      } catch (e) {
        console.info(e);
      }
      // inteoria devo trovare il modo di semplificare la select true del primo
      // aevo già fatto una funzione in merito ... vediamo
      // devo anche cambiare il selectd true sull'array del
      // vetro ...
      // cambio immagine del prodotto a sinistra
      this.changeUrl();
    },
    // ordine in cui vengono chiamate le funzioni
    // 1) click sulla card vetro  riga 85
    // 2) onCardClick riga 325
    // 3) fninituraseletect ()
    // 4) select montatura by vetro
    // QUESTA FUNZIONE MI DICE QUALE VETRO è STATO SELEZIONATO
    vetroselected() {
      // let method_name = 'vetroselected';
      this.vetroselected_ = "";
      for (let index = 0; index < this.data.vetro.length; index++) {
        const element = this.data.vetro[index];
        if (element.SELECTED == true) {
          this.vetroselected_ = element.COLOREVETRO;
        }
      }
      let obj = {
        vetro: this.vetroselected_,
        vetri: this.data.vetro,
      };
      this.$store.commit("vetro_selected", obj);
    },
    finituraselected() {
      // per ogni elemento di datastruttura trova quello con selected = true
      this.finiturastrutturaseleted = "";
      for (let index = 0; index < this.data.finiturastruttura.length; index++) {
        const element = this.data.finiturastruttura[index];
        if (element.SELECTED == true) {
          this.finiturastrutturaseleted = element.FINITURASTRUTTURA;
        }
      }
      let obj = {
        finiture: this.finiturastrutturaseleted,
        finiture_list: this.data.finiturastruttura,
      };
      this.$store.commit("finiture_selected", obj);
    },
    ledselected(led_, leds_) {
      this.SORGENTE = led_;
      this.SORGENTI = leds_;
      this.$store.commit("led_selected", { led: led_ });
      this.$store.commit("leds_selected", { leds: leds_ });
    },
    // funziona chiamata quando clicck una card della finitura montatura
    onCardClickfinitura(n) {
      // todo mettere a true quuesto elemento di finitura ...
      // credo che sia pleonastico .... ho già vetro nello store...
      // questa funzione modifica le montature del primo slider
      this.select_montature_by_finiture_metalliche(n);
    },

    select_montature_by_vetro(vetro, self = false) {
      if (!self) {
        this.select_montature_by_vetro_count = 0;
      }
      let SELECETD = true;
      let result_ = [];
      for (let ù = 0; ù < this.data.details.length; ù++) {
        const element = this.data.details[ù];
        if (
          element.COLOREVETRO == vetro &&
          element.testo_finiturastruttura == this.finiturastrutturaseleted &&
          element.PAESE == this.paese &&
          element.test_led == this.led
        ) {
          this.data.details[ù].SELECTED = SELECETD;
          // da modificare???
          this.codicearticolo_value = this.data.details[ù].id_prodotto;
          result_.push(element);
          SELECETD = false;
        } else {
          this.data.details[ù].SELECTED = false;
        }
      }
      if (result_.length == 0 && this.select_montature_by_vetro_count == 0) {
        this.select_montature_by_vetro_count = 1;
        this.dialogtitle =
          "Non esiste prodotto con queste caratteristiche cambio montatura del materiale?";
        this.changeFiniture(vetro);
        this.select_montature_by_vetro(vetro, true);
      }
      if (result_.length != 0) {
        this.data.details_old = result_;
        this.$store.commit("mutate_count_product", {
          quantita: result_.length,
        });
        this.changeUrl();
        // to do selezionare l'elemento cliccato
        this.seleziona_vetro_by_vetro(vetro);
      }
    },
    // la variabile self è una protezione per evitare che chiamo più volte
    select_montature_by_finiture_metalliche(finiture) {
      // adesso dovrebbe essere tutto più semplice qui devo solo passare finiture allo store e rifiltrare tutto
      let obj = {
        finiture: finiture,
        finiture_list: this.data.finiturastruttura,
      };
      this.$store.commit("finiture_selected", obj);
      // qui in pratica cambio l'opacità all'immagine
      this.data.finiturastruttura =
        this.$store.getters.get_finiture_list_selected;
      // l'array del paese giusto infatti è l'array del paese selezionato
      this.$store.commit("filter_product_for_vetro");
      // poi filtro per finiture
      this.$store.commit("filter_product_for_finiture");
      // poi filtro per led
      this.$store.commit("filter_product_for_led");
      this.$store.commit("product_selected");
      // todo qui devo fare il controllo sul fatto che ci sia o meno un array di lenght >0
      if (
        this.$store.getters.get_filtered_produts_vetro_finiture_sorgente
          .length != 0
      ) {
        this.data.details_old =
          this.$store.getters.get_filtered_produts_vetro_finiture_sorgente;
      } else {
        this.$store.commit("change_vetro");
        this.$store.commit("filter_product_for_vetro");
        // poi filtro per finiture
        this.$store.commit("filter_product_for_finiture");
        // poi filtro per led
        this.$store.commit("filter_product_for_led");
        this.$store.commit("product_selected");
        // todo rendere  questo elemento...
        this.data.details_old =
          this.$store.getters.get_filtered_produts_vetro_finiture_sorgente;
      }
    },
    // questa funzione seleziona la montatura in base al suo nome
    seleziona_la_montatura_by_montatura(montatura) {
      for (let index = 0; index < this.data.finiturastruttura.length; index++) {
        const element = this.data.finiturastruttura[index];
        if (element.FINITURASTRUTTURA == montatura) {
          this.data.finiturastruttura[index].SELECTED = true;
        } else {
          this.data.finiturastruttura[index].SELECTED = false;
        }
      }
      // devo anche valorizzare finiturastrutturaselected
      this.finiturastrutturaseleted = montatura;
    },

    seleziona_vetro_by_vetro(vetro) {
      // per ogni vetro vetro data.vetro
      try {
        for (let index = 0; index < this.data.vetro.length; index++) {
          const element = this.data.vetro[index];
          if (element.COLOREVETRO == vetro) {
            this.data.vetro[index].SELECTED = true;
          } else {
            this.data.vetro[index].SELECTED = false;
          }
        }
      } catch (e) {
        console.info(e);
      }
      this.finituravetro = vetro;
    },

    select_finitura_by_finitura(finitura) {
      // per ogni eto vetro data.vetro
      try {
        for (
          let index = 0;
          index < this.data.finiturastruttura.length;
          index++
        ) {
          const element = this.data.finiturastruttura[index];
          if (element.FINITURASTRUTTURA == finitura) {
            this.data.finiturastruttura[index].SELECTED = true;
          } else {
            this.data.finiturastruttura[index].SELECTED = false;
          }
        }
      } catch (e) {
        console.info(e);
      }

      this.finiturastrutturaseleted = finitura;
    },
    changeFiniture(vetro) {
      // da tutti gli articoli devo prendenre la (prima?) finitura del
      // vetro selezionato
      let i = 0;
      let ee = false;
      for (let index = 0; index < this.data.details.length; index++) {
        const element = this.data.details[index];
        if (element.COLOREVETRO == vetro && i == 0) {
          ee = element.testo_finiturastruttura;
          i = 1;
        }
      }
      this.finiturastrutturaseleted = ee;
      this.seleziona_la_montatura_by_montatura(ee);
    },
    changeVetro(finitura) {
      // da tutti gli articoli devo prendenre la (prima?) finitura del
      // vetro selezionato
      let i = 0;
      let ee = false;
      try {
        for (let index = 0; index < this.data.details.length; index++) {
          const element = this.data.details[index];
          if (element.testo_finiturastruttura == finitura && i == 0) {
            ee = element.COLOREVETRO;
            i = 1;
          }
        }
      } catch (e) {
        console.info(e);
      }
      // aggiorno il campo vetro selected
      this.vetroselected_ = ee;
      this.seleziona_vetro_by_vetro(ee);
    },
    changeUrl() {
      if (this.el == "") {
        this.el = document.getElementById("img-splash").querySelectorAll("img");
      }
      try {
        let url = "";
        for (let index = 0; index < this.data.details_old.length; index++) {
          const element = this.data.details_old[index];
          if (element.SELECTED == true) {
            url = element.img_left;
          }
        }
        this.el[0].setAttribute("src", url);
        this.el[0].insertAdjacentHTML(
          "afterend",
          this.$store.state.occhio.occhio
        );
      } catch (error) {
        console.info(error);
      }
    },
    changeUrlVALUE(url) {
      if (this.el == "") {
        this.el = document.getElementById("img-splash").querySelectorAll("img");
      }
      this.el[0].setAttribute("src", url);
      this.el[0].insertAdjacentHTML(
        "afterend",
        this.$store.state.occhio.occhio
      );
    },
    // seleziono i modelli da mostrare in base al tipo di vetro
    select_montature_by_finitura(vetro) {
      let SELECETD = true;
      let result_ = [];
      for (let ù = 0; ù < this.data.details.length; ù++) {
        const element = this.data.details[ù];
        if (element.COLOREVETRO == vetro) {
          element.SELECTED = SELECETD;
          result_.push(element);
          SELECETD = false;
        }
      }
      this.data.details_old = result_;
    },
    // questa funzione viene chiamata al create e filtra il prodotto iniziale
    filter_modelli(array) {
      // per ogni modello se finitura è tra finitura selected allora prendilo altrimenti niente
      let array_collezione_selezionata = [];
      // prendo il primo tipo di led che mi compare questo led va filtrato nell'if
      // solo se led è indefinito ? oppure ogni volta il led 1 forse meglio led 1
      if (this.finituravetro == "") {
        this.finituravetro = this.$store.getters.get_vetro_selected;
      }
      //todo:// get paese ___ standard CE dovrebbe dipendere dal cliente
      // se utente loggato devo individuare il suo id
      // quindi if user logged in (backend)
      // dal suo id capire il suo paese
      // inoltre il prezzo cambia in base ai suoi sconti ...
      // quindi cerchiamo di fare in modo che standard sia CE
      // adesso proviamo a filtrare la lista riferimento per i filtri
      // https://www.digitalocean.com/community/tutorials/js-filter-array-method
      this.$store.commit("filter_product_for_paese", {
        PAESE: this.$store.getters.get_paese_selected,
        products: array,
      });
      this.$store.commit("filter_product_for_vetro");
      this.$store.commit("filter_product_for_finiture");
      this.$store.commit("filter_product_for_led");
      this.$store.commit("product_selected");
      this.codicearticolo_value = this.$store.state.product.id;
      // attenzione questa lista me la devo aggiornare ogni volta che clicco o
      // su finitura o su montatura
      this.$store.commit("mutate_list_products", {
        listasorgenti: array_collezione_selezionata,
      });
      // select true ovvero rendi non opaca la foto dell'elemento
      this.data.details_old =
        this.$store.getters.get_filtered_produts_vetro_finiture_sorgente;
      this.$store.commit("mutate_count_product", {
        quantita: this.data.details_old.length,
      });
    },
    // oncard click modello chiamato a linea 34 dal gruppo modelli
    // questo metodo deve cambiare due cose
    // 1) l'immagine del modello a sinistra
    // 2) il selected nell'array details
    // 3) come tutti gli altri dovrebbe anche cambiare i led disponibili
    // in realtà i led non è un filtro almeno spero ...
    // in questo caso passo come attributo della funzione modello_var che può
    // essere G L grande piccolo come vuoi
    foreach_list_exist(
      list,
      attribute,
      value,
      changing,
      return_value = false,
      return_value_2 = false
    ) {
      let returnvalue;
      let returnvalue2;
      for (let index = 0; index < list.length; index++) {
        if (list[index][attribute] == value) {
          list[index][changing] = true;
          if (return_value) {
            returnvalue = list[index][return_value];
          }
          if (return_value_2) {
            returnvalue2 = list[index][return_value_2];
          }
        } else {
          list[index][changing] = false;
        }
      }
      return {
        list: list,
        return_value: returnvalue,
        return_value_2: returnvalue2,
      };
    },
    aggiorna_sorgente_luminosa(sorgente) {
      // qui devo aggiornare le sorgenti luminose in modo che sia selezionata
      // la sorgente luminosa del prodotto a true
      // inoltre dovrei fare un controllo delle sorgenti disponibili ...
      // ho comunque una variabile con tutte le sorgenti ... in teoria posso aggiornare
      // tutto quello che mi pare in base alla sorgente luminosa selezionata
      // per semplicità però cambierei solo la lista modelli
      // la select delle sorgenti è a riga 169
      this.data.sorgenti_estese.model.SORGENTE = sorgente;
    },
    modifica_liste_al_click_di_sorgente_luminosa() {
      // aggiorno lo store con il led selezionato ...
      this.$store.commit("led_selected", { led: this.SORGENTE });
      // filtro per paese? no .. il paese non è cambiato
      this.$store.commit("filter_product_for_vetro");
      this.$store.commit("filter_product_for_finiture");
      this.$store.commit("filter_product_for_led");
      this.data.details_old =
        this.$store.getters.get_filtered_produts_vetro_finiture_sorgente;
      this.$store.commit("product_selected");
      this.codicearticolo_value = this.$store.state.product.id;
    },
    add_prezzi(prezzi) {
      this.$store.commit("add_prezzi", { prezzi: prezzi });
      this.$store.commit("filter_prezzo");
    },
    add_sorgenti(ul, ce) {
      let obj = {
        ul: ul,
        ce: ce,
      };
      this.$store.commit("add_sorgenti_estese", obj);
    },
    increment() {
      this.quantity++;
      this.$store.commit("setta_quantita_richiesta", this.quantity);
    },
    decrement() {
      if (this.quantity === 1) {
        this.wer = "234";
      } else {
        this.quantity--;
      }
      this.$store.commit("setta_quantita_richiesta", this.quantity);
    },
  },
  async created() {
    // registro lo sku
    this.sku = window.descrizione.sku;
    this.certificazioni = this.$store.state.certificazioni;
    this.finituravetro_text = this.$store.state.finituravetro_text;
    this.sorgenteluminosa = this.$store.state.sorgenteluminosa;
    this.zona = this.$store.state.zona;
    this.zona_u = this.$store.state.zona_u;
    this.codicearticolo_title = this.$store.state.codicearticolo_title;
    this.codicearticolo_value = "JUBE-000-1-CELW-21";
    this.disponibilità_top_text_number = "12";
    (this.certificazioni = {
      usa: this.$store.state.usa,
      europe: this.$store.state.europe,
    }),
      (this.paese = this.$store.state.paese);
    this.url = window.location.hostname;
    let url = this.url;
    let that = this;
    this.get = window.descrizione.get;
    if (typeof this.get.id !== "undefined") {
      this.show_product_id(this.get.id);
      this.idtoshow = this.get.id;
    } else {
      this.idtoshow = false;
    }
    this.product_wid(window.descrizione.wid);
    this.switcher();
    if (url != "localhost") {
      // questo viene eseguito live
      // se è selezionato un prodotto specifico // in teoria ho un id che mi da questo prodotto specifico
      let self = this;
      let gjp = new get_json_product();
      let prodk = this.sku;
      gjp.get_json_product_dev(prodk, that, self);
    } else {
      let self = this;
      let gjp = new get_json_product();
      let prodk = this.sku;
      gjp.get_json_product_dev(prodk, that, self);
    }
  },
  computed: {
    discountd_price() {
      let n = parseFloat(
        parseFloat(this.$store.state.product_store.PREZZO)
      ).toFixed(2);
      n = parseFloat(n * this.discount_percentage).toFixed(2);
      let c = n.toString().replace(".", ",");
      const formatted = c.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return formatted;
    },
    COMPONENT_URL() {
      return this.$store.state.STATUS.url;
    },
    COMPONENT_STATUS() {
      return this.$store.state.status.status;
    },
    valuta() {
      //   PREZZO LISTINO CORRENTE
      let valuta = "€";
      //   LISTINO DOLLARI CANADA
      if (this.$store.state.product.codice_listino == "6") {
        valuta = "c$";
      }
      //   LISTINO DOLLARI
      if (this.$store.state.product.codice_listino == "7") {
        valuta = "$";
      }
      //   LISTINO FEDERAZIONE RUSSA
      if (this.$store.state.product.codice_listino == "100") {
        valuta = "₽";
      }
      //   LISTINO AUSTRALIA
      if (this.$store.state.product.codice_listino == "101") {
        valuta = "A$";
      }
      //   VM PRICE LIST ESTONIA
      if (this.$store.state.product.codice_listino == "102") {
        valuta = "kr";
      }
      //   VM PRICE LIST MESSICO
      if (this.$store.state.product.codice_listino == "103") {
        valuta = "Mex$";
      }
      //   VM PRICE LIST UCRAINA
      if (this.$store.state.product.codice_listino == "106") {
        valuta = "UAH";
      }
      //   VM PRICE LIST BIELORUSSIA
      if (this.$store.state.product.codice_listino == "107") {
        valuta = "Br";
      }
      //   VM PRICE LIST FINLAND
      //   EURO
      //   this.$store.state.product.codice_listino == "108")
      //   LISTINO INGHITERRA
      if (this.$store.state.product.codice_listino == "109") {
        valuta = "£";
      }
      //   VM PRICE LIST IRLAND
      //   EURO
      //   this.$store.state.product.codice_listino == "110")
      //   LISTINO BRASILE
      if (this.$store.state.product.codice_listino == "111") {
        valuta = "R$";
      }
      //   VM PRICE LIST  NORVEGIA
      if (this.$store.state.product.codice_listino == "114") {
        valuta = "NOK";
      }
      //   VM PRICE LIST  SVEZIA
      if (this.$store.state.product.codice_listino == "115") {
        valuta = "SEK";
      }
      //   VM PRICE LIST  GIAPPONE
      if (this.$store.state.product.codice_listino == "116") {
        valuta = "¥";
      }
      //   VM PRICE LIST UK ?? Doppione?
      if (this.$store.state.product.codice_listino == "117") {
        valuta = "£";
      }
      //   VM PRICE LIST BULGARIA
      if (this.$store.state.product.codice_listino == "118") {
        valuta = "лв";
      }
      //   VM PRICE LIST SINGAPORE
      if (this.$store.state.product.codice_listino == "119") {
        valuta = "S$";
      }
      //   VM PRICE LIST CIPRO
      //   EURO
      //   this.$store.state.product.codice_listino == "120")
      //   VM PRICE LIST GRECIA
      //   EURO
      //   this.$store.state.product.codice_listino == "121")
      //   VM PRICE LIST SINGAPORE
      if (this.$store.state.product.codice_listino == "122") {
        valuta = "֏";
      }
      //   VM PRICE LIST SINGAPORE
      if (this.$store.state.product.codice_listino == "123") {
        valuta = "฿";
      }

      return valuta;
    },
    prezzounitario() {
      let n = parseFloat(
        parseFloat(this.$store.state.product_store.PREZZO)
      ).toFixed(2);
      let c = n.toString().replace(".", ",");
      const formatted = c.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return formatted;
    },
    showid() {
      return this.$store.state.product.showid;
    },
    sorgenteluminosa_: {
      get() {
        let i = new checkLanguage();
        if (!i.is_italian()) {
          return "LIGHT SOURCE";
        } else {
          let language = this.$store.state.product.language;
          return this.$store.state[language].sorgenteluminosa;
        }
      },
      set(te) {
        return te;
      },
    },
    finituravetro_text_: {
      get() {
        let i = new checkLanguage();
        if (!i.is_italian()) {
          return "GLASS FINISH";
        } else {
          let language = this.$store.state.product.language;
          return this.$store.state[language].finituravetro_text;
        }
      },
      set(finitura) {
        return finitura;
      },
    },
    debug() {
      return this.$store.state.products.debug;
    },
    explode_vetro(s) {
      return s.substr(0, 2);
    },
    led() {
      return this.$store.getters.led_selectd;
    },
  },
};
</script>
<style scoped>
.paginaprodotto p {
  margin: 0;
  padding: 0;
}
.mdi-chevron-right {
  width: 52px;
  height: 52px;
}
.active_image {
  opacity: 1;
}
.not_active_image {
  opacity: 0.3;
}
.BOX {
  width: 100px;
  height: 100px;
}
.flex-container.wrap {
  display: flex;
  flex-wrap: wrap;
}
.flex-container {
  width: 500px;
}
.product-list-modello {
  display: flex;
  flex-direction: column;
}
.no-margin {
  padding: 0 !important;
  margin: 0 !important;
  margin-top: -40px !important;
  font-weight: 400;
  font-size: 19px;
  text-align: left;
  width: 58%;
}
.no-shadow {
  box-shadow: none !important;
}
.flex_struttura {
  display: flex;
  flex-direction: column;
}
.flex_vetro {
  display: flex;
  flex-direction: column;
  margin: 0;
}
.maiuscoletto_opaco_piccolo {
  font-weight: 400;
  opacity: 1;
  font-size: 5px !important;
  color: #656565;
}
.pesante_scuro {
  font-weight: 550;
  font-size: 14px;
  text-align: left !important;
  align-content: flex-start !important;
}
.img_vetro {
  height: 70px;
  width: 70px;
  object-fit: contain;
  padding-bottom: 0px;
}

.img_montatura {
  height: 70px;
  width: 70px;
  object-fit: contain;
  padding-bottom: 0px;
}
.opaco_si {
  opacity: 0.5;
}
p.vetro_testo {
  margin: 0;
  padding-top: 12px;
  text-align: left !important;
}
.v-card-rompi::before {
  display: none;
}
.paginaprodotto {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
}
.finitura_vetro p {
  padding-left: 70px;
  margin-bottom: 7px;
  font-size: 13px !important;
}
.finitura_montatura p {
  padding-left: 70px;
  margin-bottom: 7px;
  margin-bottom: -15px;
}
.montatura-sheet {
  margin-left: 53px !important;
  margin-top: -26px;
}
.testo_modelli {
  font-size: 15px;
  font-weight: 600;
}

.v-select__selections input {
  border: 0 !important;
  outline: 0 !important;
  background: transparent !important;
  border-image: none !important;
  outline-offset: -2px !important;
  border-color: transparent !important;
  outline-color: transparent !important;
  box-shadow: none !important;
  -webkit-appearance: none !important;
}
.list-sorgente-luminosa {
  padding-left: 70px;
  min-width: 85%;
}
.padding-title {
  padding-left: 70px !important;
}
.testo_finitura_vetro,
.finitura_montatura {
  position: relative;
  z-index: 20;
  margin-bottom: 7px;
}
.sorgente_luminosa_p p {
  font-weight: 500 !important;
  font-size: 13px !important;
  padding-top: 20px;
}

.titoletto_certificazioni {
  font-weight: 500 !important;
  font-size: 13px !important;
  padding-left: 70px;
  padding-top: 20px;
}

.montatura-vetro {
  margin-top: -35px;
}
p.finitura_montatura {
  font-weight: 500 !important;
  font-size: 13px !important;
  padding-bottom: 12px;
}
.list-prezzo {
  width: 50%;
}
.certificazioni_flex {
  display: flex;
  flex-direction: row;
  width: 78%;
}
.not_active_button {
  opacity: 0.5;
}

.quantity_toggle {
  display: flex;
  margin-left: 70px;
  margin-top: 0px;
  margin-bottom: 0px;
  border: 0.5px;
  border-color: #888;
  border-style: solid;
}

.quantity_toggle_input {
  border-top: none !important;
  border-bottom: none !important;
  width: 2.5rem;
  text-align: center;
  padding: 0 0.5rem;
  background: #ffffff;
  border-left: solid;
  border-left-width: 0.1rem;
  border-left-color: rgb(204, 204, 204);
  border-right: solid;
  border-right-width: 0.1rem;
  border-right-color: rgb(204, 204, 204);
}

.quantity_toggle_button {
  padding: 0.5rem;
  background: #ffffff;
  color: #888;
  font-size: 1rem;
  cursor: pointer;
}

.button-eletrificazioni {
  min-width: 55% !important;
  padding-top: 10px;
}

.v-text-field {
  padding-top: 0px !important;
}

.v-slide-group__wrapper {
  padding-top: 6% !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: 0px;
}

.list-codicearticolo {
  padding-top: 15px;
}

.codice_articolo_value_maiuscoletto {
  font-weight: 550;
  font-size: 13px;
  text-align: left !important;
  padding-top: 5px !important;
}

.list-disponibilità_text {
  padding-top: 15px;
}

.disponibilità_top_text {
  font-weight: 400;
  font-size: 13px;
  text-align: left !important;
  padding-top: 10px !important;
}

.button-buy-under-text-center {
  text-align: center !important;
  padding-left: 70px;
  padding-top: 20px;
  padding-bottom: 50px;
}
.div_min_width_20 {
  min-width: 15px !important;
}

.row_double_button {
  margin-top: 15px !important;
}

.prezzo_finale {
  font-weight: 500;
  font-size: 29px;
  text-align: left !important;
  padding-top: 5px !important;
  padding-bottom: 15px !important;
}

.titoletto_certificazioni {
  font-weight: 500 !important;
  font-size: 13px !important;
  padding-left: 70px !important;
  padding-top: 20px !important;
}

.certificazioni_flex {
  display: flex !important;
  flex-direction: row !important;
  width: 100% !important;
}

.button-eletrificazioni {
  min-width: 55% !important;
  padding-top: 10px;
}

.product-list-modello:focus::before {
  background: #ffffff00 !important;
  opacity: unset !important;
}
.vetro-slider {
  margin-left: 55px;
}
.sorgente_luminosa_padding_zero {
  padding-top: 0 !important;
}
.price_quantity_wrapper .quantity_toggle.quantity_toggle_position {
  display: flex;
  flex-direction: row;
  width: 109px;
}
.prezzo_unitario_flex {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.prezzo_unitario {
  font-weight: 500;
  font-size: 24px;
  text-align: left !important;
  padding-top: 5px !important;
  padding-bottom: 0px !important;

  margin-bottom: 0px !important;
  margin-right: 30px !important;
}
.montatura_margin {
  margin-bottom: 20px !important;
}
.finiture-montature-09587 {
  margin-top: 30px;
}
.prezzo_scontato_wrapper {
  display: flex;
  flex-direction: column;
}
.prezzo_scontato_wrapper p {
  font-size: 15px !important;
}
.test_div {
  display: none;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  /* Your Styles... */

  .test_div {
    min-width: 53vw !important;

    min-height: 10px;
    width: 20vw;
    display: block;
  }
  .list-modelli {
    margin-top: -88px;
  }
  .list_vetri_wrapper_container {
    display: flex;
    flex-direction: row;
    margin-top: -210px;
  }
  .list_finiture_wrapper_container {
    display: flex;
    flex-direction: row;
    margin-top: -48px;
  }
  .single-product .vetro-slider {
    margin-top: -71px !important;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) and (orientation: landscape) {
  .list_vetri_wrapper_container .count_proddoto {
    padding-bottom: 55px !important;
  }
  .list_vetri_wrapper_container {
    margin-top: -282px;
  }
}
.whishlist {
  border: 1px solid black;
  max-width: 347px;

  padding: 11px 15px;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  cursor: pointer;
  background-color: black;
  margin-bottom: 30px;
}
.whishlist:hover {
  background-color: white;
}
#text_cuore {
  fill: white !important;
}
.text_addwishlist:hover {
  color: #000;
}
.whishlist:hover .text_addwishlist {
  color: #000;
}
.whishlist:hover #Tracciato_51060 {
  stroke: black;
}
.text_addwishlist {
  margin-bottom: 0px;
  padding-bottom: 0px;

  line-height: 32px;
  margin-left: 10px;
  line-height: 40px;
  color: white;
}
.cicle_stroke {
  stroke: white !important;
}
</style>
